/* @jsx jsx */
import { jsx } from "theme-ui";
import { NotionRenderer as ReactNotionRenderer } from "react-notion";
import { useMatch } from "@reach/router";
import { getPrettyHelpUrl } from "../utils";
import Link from "./Link";
import { NotionRendererProps } from "react-notion/dist/renderer";
import { Code } from "./Code";

const mapPageUrl = (notionId: string) => getPrettyHelpUrl(notionId);

export default function NotionRenderer(props: NotionRendererProps) {
  const params = useMatch(`/app/:projectId`);
  return (
    <ReactNotionRenderer
      mapPageUrl={mapPageUrl}
      {...props}
      customBlockComponents={{
        page: ({ blockValue, renderComponent }) => {
          if (!blockValue.properties) return null;
          return (
            <Link to={mapPageUrl(blockValue.id)}>{renderComponent()}</Link>
          );
        },
        code: ({ blockValue }) => {
          if (blockValue.properties.title) {
            const content = blockValue.properties.title[0][0];
            const language = blockValue.properties.language[0][0];
            return (
              <Code
                projectId={params?.projectId}
                key={blockValue.id}
                language={language || ""}
                code={content}
              />
            );
          }
          return null;
        },
        ...(props.customBlockComponents || {}),
      }}
      customDecoratorComponents={{
        a: ({ children, decoratorValue }) => (
          <Link to={decoratorValue} className="notion-link">
            {children}
          </Link>
        ),
        ...(props.customDecoratorComponents || {}),
      }}
    />
  );
}
